var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", {
      directives: [
        {
          name: "wechat-title",
          rawName: "v-wechat-title",
          value: _vm.$route.meta.title,
          expression: "$route.meta.title"
        }
      ]
    }),
    _vm._v(" "),
    _c("div", { staticClass: "app-container" }, [
      _c(
        "div",
        { staticClass: "picker-box" },
        [
          _c("VuePicker", {
            attrs: {
              data: _vm.pickData,
              showToolbar: true,
              defaultIndex: _vm.pickerDefaultIndex,
              cancelText: "إلغاء",
              confirmText: "تأكيد",
              visible: _vm.pickerVisible
            },
            on: {
              cancel: _vm.cancel,
              confirm: _vm.confirm,
              "update:visible": function($event) {
                _vm.pickerVisible = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.UserInfo.uid == ""
        ? _c("div", { staticClass: "id-content" }, [
            _c(
              "button",
              {
                staticClass: "id-comfirm",
                class: _vm.user_id ? "" : "disabled",
                on: { click: _vm.checkUserInfo }
              },
              [_vm._v("تأكيد")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user_id,
                  expression: "user_id"
                }
              ],
              ref: "id_input",
              staticClass: "id-input",
              attrs: { maxlength: "7", type: "text" },
              domProps: { value: _vm.user_id },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.user_id = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.placeholderIsShow,
                    expression: "placeholderIsShow"
                  }
                ],
                staticClass: "input-placeholder",
                on: {
                  click: function($event) {
                    return _vm.onFocus()
                  }
                }
              },
              [_c("span", [_vm._v("بوبو ID ")]), _vm._v("الرجاء إدخال")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "leader-input-mask",
                staticStyle: { position: "absolute", right: "0" },
                on: { click: _vm.hideLeaderMask }
              },
              [
                _vm.LeaderMask
                  ? _c("input", {
                      staticClass: "id-input leader-input",
                      attrs: { maxlength: "11", readonly: "true", type: "text" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.LeaderMask
                  ? _c("span", { staticClass: "input-placeholder" }, [
                      _c("span", [_vm._v("بوبو ID ")]),
                      _vm._v("الرجاء إدخال")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.LeaderMask
                  ? _c("span", { staticClass: "leader-input-text" }, [
                      _c("span", [_vm._v(" بوبو ID")]),
                      _vm._v(" انقر لإدخال ")
                    ])
                  : _vm._e()
              ]
            )
          ])
        : _c("div", { staticClass: "user-content" }, [
            _c("p", { staticClass: "user-bobo-name" }, [
              _vm._v(_vm._s(_vm.UserInfo.name))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "user-bobo-id" }, [
              _vm._v("ID：" + _vm._s(_vm.UserInfo.showId))
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "user-bobo-cover",
              attrs: { src: _vm.UserInfo.cover, alt: "" }
            })
          ]),
      _vm._v(" "),
      _vm.UserInfo.uid == ""
        ? _c("div", { staticClass: "what-boboID" }, [
            _c("span", { on: { click: _vm.showBOBOID } }, [
              _c("span", [_vm._v("بوبو؟  ID ")]),
              _vm._v(" ما هو ")
            ])
          ])
        : _c(
            "div",
            { staticClass: "change-user", on: { click: _vm.changeUser } },
            [_c("span", [_vm._v(" بوبو اخر ID ")]), _vm._v(" الشحن لـ")]
          ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "recharge-content" },
        [
          _c("div", { staticClass: "recharge-title" }, [
            _c("span", {
              staticClass: "choose-country",
              domProps: { textContent: _vm._s(_vm.ShowCountry) },
              on: { click: _vm.changeCountry }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                style: _vm.rechargeList.length > 0 ? "opacity: 1" : "opacity: 0"
              },
              [_vm._v("طرق الشحن")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { position: "absolute", left: "0", width: "2rem" },
                on: { click: _vm.hideLeaderMask }
              },
              [
                _vm.LeaderMask
                  ? _c(
                      "span",
                      { staticClass: "choose-country leader-country" },
                      [_vm._v("المملكة العربية السعودية")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.LeaderMask
                  ? _c("span", { staticClass: "leader-country-text" }, [
                      _vm._v(" انقر لأختيار بلد الدفع ")
                    ])
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.rechargeList, function(item, index) {
            return _c(
              "div",
              { key: item.channelName + "_" + index, staticClass: "list" },
              [
                _c(
                  "div",
                  {
                    ref: "list_items",
                    refInFor: true,
                    staticClass: "list-items",
                    on: {
                      click: function($event) {
                        return _vm.toggleItem(index)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "left-icon",
                      class: item.show ? "" : "active"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "right-name" }, [
                      _vm._v(_vm._s(item.channelName))
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "right-img",
                      attrs: {
                        src:
                          item.channelName.indexOf("VISA/Master") > -1
                            ? _vm.VISACard
                            : item.channelImage,
                        alt: ""
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                item.show
                  ? _c(
                      "div",
                      { staticClass: "items-content" },
                      _vm._l(item.gears, function(r_item, ind) {
                        return _c(
                          "div",
                          { key: ind, staticClass: "list-item" },
                          [
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.goRecharge(
                                        item.channelName,
                                        r_item.name
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(r_item.currency) +
                                      " " +
                                      _vm._s(r_item.price)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "right-info" }, [
                                _c("span", [_vm._v(_vm._s(r_item.amount))])
                              ])
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "question", on: { click: _vm.goQuestion } }, [
        _vm._v("الأسئلة الشائعة")
      ])
    ]),
    _vm._v(" "),
    _vm.tips != ""
      ? _c("div", { staticClass: "tips", class: { on: _vm.tips != "" } }, [
          _c("p", [_vm._v(_vm._s(_vm.tips))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showImg,
            expression: "showImg"
          }
        ],
        staticClass: "bobo-mask",
        on: { click: _vm.showBOBOID }
      },
      [_vm._m(1)]
    ),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.StopMask,
          expression: "StopMask"
        }
      ],
      staticClass: "stop-mask"
    }),
    _vm._v(" "),
    _vm.LeaderMask
      ? _c("div", {
          staticClass: "leader-mask",
          on: { click: _vm.hideLeaderMask }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-tips" }, [
      _c("p", { staticClass: "tips1" }, [_vm._v("الحساب المراد شحنه")]),
      _vm._v(" "),
      _c("p", { staticClass: "tips2" }, [
        _vm._v("يرجى التحقق من معلومات الحساب المراد شحنه")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bobo" }, [
      _c("span", { staticClass: "close-bobo" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6028a368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6028a368","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tips.vue
// module id = null
// module chunks = 